export default {
  PACKAGE: 'EKB-PACKAGE',
  RESOURCE: 'EKB-TITLE',
};
